// extracted by mini-css-extract-plugin
export default {"wrapper":"lessons-list_wrapper__hEKJJ","listReveal":"lessons-list_listReveal__3BDoQ"};